module.exports = __webpack_public_path__ + "img/xiaochegnxu.33c88e0f.jpg";